import { ContentPopulate } from './contents';
import { HandlePopupRequestApiDto, PopupApiDto, PopupEventApiType } from './dto';
import { apiRequest, BaseOptions, getBaseOptions, Populate } from './utils/util';

const rootPath = '/v2/popups';

export interface PopupPopulate {
  content?: Populate<ContentPopulate>;
  offer?: boolean;
}

export interface HandlePopupsOptions extends BaseOptions {
  populate: PopupPopulate;
}

export const handlePopups = async <T>(
  event: PopupEventApiType,
  url: string,
  popupsToExclude: Array<string>,
  data: HandlePopupRequestApiDto,
  options?: HandlePopupsOptions
) =>
  apiRequest<Array<PopupApiDto<T>>, HandlePopupRequestApiDto, PopupPopulate>({
    ...getBaseOptions(options),
    data,
    method: 'POST',
    params: {
      event,
      popupsToExclude,
      url,
    },
    populate: options?.populate,
    url: `${rootPath}`,
  });

export interface GetPopupByIdOptions extends BaseOptions {
  populate: PopupPopulate;
}

export const getPopupById = async <T>(id: string, options?: GetPopupByIdOptions, staleTime = Infinity) =>
  apiRequest<PopupApiDto<T>, void, PopupPopulate>({
    ...getBaseOptions(options),
    populate: options?.populate,
    staleTime,
    url: `${rootPath}/${id}`,
  });
